(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../scroll-view", "../transition", "../_mixins/resizeOb", "../_mixins/tabBar"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../scroll-view"), require("../transition"), require("../_mixins/resizeOb"), require("../_mixins/tabBar"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.scrollView, global.transition, global.resizeOb, global.tabBar);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _scrollView, _transition, _resizeOb, _tabBar) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _scrollView = _interopRequireDefault(_scrollView);
  _transition = _interopRequireDefault(_transition);
  _tabBar = _interopRequireDefault(_tabBar);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nav', {
        class: [_vm.positionType, {
          'bottom-border': _vm.bottomBorder,
          'nx-tab-bar': true,
          'nx-os-blur-material': _vm.blurMaterial
        }],
        style: {
          backgroundColor: _vm.barBgColor || _vm.tabBarStyle.barBgColor
        }
      }, [_c('div', {
        ref: "wrapper",
        staticClass: "nx-tab-bar-inner"
      }, [_vm.scrollable && !_vm.banScrollX && !_vm.barBgColor && !_vm.tabBarStyle.barBgColor ? [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.maskStart && _vm.maskStartShown,
          expression: "maskStart && maskStartShown"
        }],
        staticClass: "nx-tab-bar-start"
      }), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.maskEnd && _vm.maskEndShown,
          expression: "maskEnd && maskEndShown"
        }],
        staticClass: "nx-tab-bar-end"
      })] : _vm._e(), _c('nx-scroll-view', {
        key: _vm.scrollerTmpKey,
        ref: "scroller",
        attrs: {
          "scrolling-x": _vm.scrollable && !_vm.banScrollX,
          "scrolling-y": false,
          "isPrevent": _vm.isPrevent,
          "immediateAnimation": _vm.immediateAnimation
        },
        on: {
          "scroll": _vm.$_onScroll
        }
      }, [_c('div', {
        staticClass: "nx-tab-bar-wrap",
        style: {
          width: _vm.contentW + 'px'
        }
      }, [_c('div', {
        staticClass: "nx-tab-bar-list",
        class: [_vm.scrollable ? 'nx-tab-bar-list-sb' : 'nx-tab-bar-list-sa'],
        style: {
          width: _vm.wrapperW + 'px'
        }
      }, _vm._l(_vm.items, function (item, index) {
        return _c('div', {
          key: item.name,
          ref: "items",
          refInFor: true,
          staticClass: "nx-tab-bar-item",
          class: [_vm.flexDirection],
          on: {
            "click": function click($event) {
              return _vm.$_onClick(item, index);
            }
          }
        }, [_c('div', {
          class: ['inside', {
            'is-active': _vm.currentName === item.name,
            'is-disabled': !!item.disabled,
            'is-slide': _vm.tabBarType === 'slide'
          }, _vm.flexDirection],
          style: {
            color: _vm.currentIndex == index ? _vm.selectColor || _vm.tabBarStyle.selectColor : _vm.unSelectColor || _vm.tabBarStyle.unSelectColor
          },
          attrs: {
            "aria-label": "" + (item.disabled ? (item.ariaLabelContent || item.label) + "，已禁用" : _vm.currentName === item.name ? "'已选中，" + (item.ariaLabelContent || item.label) : "未选中，" + (item.ariaLabelContent || item.label) + "'，点按两次即可激活'"),
            "tabindex": item.ariaLabelContent || item.label ? '1' : 'undefined'
          }
        }, [_vm._t("default", [_vm._v(_vm._s(item.label))], {
          "item": item,
          "items": _vm.items,
          "index": index,
          "currentName": _vm.currentName
        }), _c('nx-transition', {
          attrs: {
            "name": "nx-tab-bar-ink-fixed"
          }
        }, [_vm.isFixedTabBar && _vm.currentName === item.name ? _c('span', {
          staticClass: "nx-tab-bar-ink",
          class: {
            'is-disabled': _vm.currentTab && _vm.currentTab.disabled
          },
          style: [{
            backgroundColor: _vm.currentTab && _vm.currentTab.disabled ? undefined : _vm.inkColor || _vm.tabBarStyle.inkColor
          }]
        }) : _vm._e()])], 2)]);
      }), 0)]), _vm.isSlideTabBar ? _c('span', {
        staticClass: "nx-tab-bar-ink",
        class: {
          'is-disabled': _vm.currentTab && _vm.currentTab.disabled,
          'nx-tab-bar-ink-slide': _vm.tabBarType === 'slide'
        },
        style: [{
          width: _vm.inkWidth + 'px',
          transform: "translate3d(" + _vm.inkPos + "px, 0, 0)",
          backgroundColor: _vm.currentTab && _vm.currentTab.disabled ? undefined : _vm.inkColor || _vm.tabBarStyle.inkColor
        }, _vm.inkStyle]
      }) : _vm._e()])], 2)]);
    },
    name: 'nx-tab-bar',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _scrollView.default.name, _scrollView.default), (0, _defineProperty2.default)(_components, _transition.default.name, _transition.default), _components),
    mixins: [_resizeOb.resizeOb, _tabBar.default],
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      items: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      hasInk: {
        type: Boolean,
        default: true
      },
      immediate: {
        type: Boolean,
        default: false
      },
      banScrollX: {
        type: Boolean,
        default: false // 禁止横滑【该属性已废弃】

      },
      bottomBorder: {
        type: Boolean,
        default: false
      },
      positionType: {
        type: String,
        default: 'relative' // tabBar 位置，relative（默认）：默认布局，top：居顶，bottom：居底

      },
      flexDirection: {
        type: String,
        default: 'flex-row' // tabIcon 排列方式，flex-row（默认）：横向，flex-column：纵向

      },
      inkPosRadio: {
        type: Number,
        // [0,1]
        default: 0 // 控制滑动的距离比例

      },
      tabBarType: {
        type: String,
        default: 'fixed' // 可横滑tab为slide, 不可横滑为fixed

      },
      immediateAnimation: {
        type: Boolean,
        default: true
      },
      // 初始化时是否有滚动动效
      maskStart: {
        type: Boolean,
        default: true
      },
      maskEnd: {
        type: Boolean,
        default: true
      },
      isPrevent: {
        type: Boolean,
        default: true
      },
      blurMaterial: {
        type: Boolean,
        default: false
      }
    },
    data: function data() {
      return {
        currentName: '',
        wrapperW: 0,
        contentW: 0,
        inkWidth: 0,
        inkPos: 0,
        scrollerTmpKey: Date.now(),
        maskStartShown: false,
        maskEndShown: true,
        inkStyle: {}
      };
    },
    computed: {
      scrollable: function scrollable() {
        return this.contentW > this.wrapperW + 1;
      },

      /* eslint-disable vue/return-in-computed-property */
      currentIndex: function currentIndex() {
        for (var i = 0, len = this.items.length; i < len; i++) {
          if (this.items[i].name === this.currentName) {
            return i;
          }
        }
      },

      /* eslint-disable vue/return-in-computed-property */
      currentTab: function currentTab() {
        if (this.currentIndex) {
          return this.items[this.currentIndex];
        }
      },
      isSlideTabBar: function isSlideTabBar() {
        return this.hasInk && this.tabBarType === 'slide';
      },
      isFixedTabBar: function isFixedTabBar() {
        return this.hasInk && this.tabBarType === 'fixed';
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function handler(val) {
          if (val !== this.currentName) {
            this.currentName = val;
          }
        }
      },
      items: function items() {
        this.$nextTick(function () {
          this.reflow();
        });
      },
      currentIndex: function currentIndex(_new, _old) {
        var noAnimate = _old === undefined && !this.immediateAnimation;

        if (noAnimate) {
          this.inkStyle = {};
        } else {
          // this.inkStyle = {
          //   transition: `all ${300 + Math.abs(_new - _old) * 50}ms cubic-bezier(0.28, 0.4, 0.2, 1)`,
          // }
          this.inkStyle = {
            transition: "all ".concat(350, "ms cubic-bezier(0.28, 0.4, 0.2, 1)")
          };
        }

        this.$nextTick(function () {
          this.reflow({
            animate: !noAnimate
          });
        });
      },
      scrollable: function scrollable() {
        this.scrollerTmpKey = Date.now();
      },
      inkPosRadio: function inkPosRadio() {
        this.inkStyle = {
          transition: "all 300ms cubic-bezier(0.28, 0.4, 0.2, 1)"
        };
        this.$nextTick(this.refreshInkPosRadioAndPos);
      }
    },
    created: function created() {
      this.inkStyle = {};

      if (this.currentName === '' && this.items.length) {
        this.currentName = this.items[0].name; // this.$emit('change', this.items[0], 0, 0)
      }
    },
    mounted: function mounted() {
      var _this = this;

      // 横竖屏切换
      window.addEventListener('resize', this.reflow);
      this.$nextTick(function () {
        _this.reflow({
          animate: _this.immediateAnimation
        });
      });

      if (this.immediate) {
        this.$nextTick(function () {
          _this.$emit('change', _this.items[_this.currentIndex], _this.currentIndex, _this.currentIndex);
        });
      }

      this.$obReInit({
        cbHeight: function cbHeight() {
          _this.reflow({
            animate: false
          });

          _this.$nextTick(function () {
            _this.$emit('changeTabBarHeight', _this.$el.offsetHeight);
          });
        },
        cbWidth: function cbWidth() {
          _this.$nextTick(function () {
            _this.reflow({
              animate: false
            });
          });
        }
      });
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('resize', this.reflow);
    },
    methods: {
      // MARK: private events
      $_onScroll: function $_onScroll(_ref)
      /* istanbul ignore next */
      {
        var scrollLeft = _ref.scrollLeft;

        if (scrollLeft > 0) {
          this.maskStartShown = true;
        } else {
          this.maskStartShown = false;
        }

        if (scrollLeft >= this.$refs.scroller.contentW - this.$refs.scroller.containerW) {
          this.maskEndShown = false;
        } else {
          this.maskEndShown = true;
        }

        this.$emit('onTabBarScroll', {
          maskStartShown: this.maskStartShown,
          maskEndShown: this.maskEndShown,
          scrollLeft: scrollLeft
        });
      },
      $_onClick: function $_onClick(item, index) {
        if (item.disabled) {
          return;
        }

        this.$emit('change', item, index, this.currentIndex);
        this.currentName = item.name;
        this.$emit('input', item.name);
      },
      // MARK: public methods
      reflow: function reflow() {
        var _this2 = this;

        var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          animate: true
        };

        if (!this.$refs.items || this.$refs.items.length === 0) {
          return;
        }

        this.wrapperW = this.$refs.wrapper.offsetWidth;
        var contentWidth = 0;

        for (var i = 0, len = this.items.length; i < len; i++) {
          contentWidth += this.$refs.items[i].offsetWidth + parseFloat(getComputedStyle(this.$refs.items[i]).marginLeft) + parseFloat(getComputedStyle(this.$refs.items[i]).marginRight);
        }

        this.contentW = contentWidth;
        this.$refs.scroller.reflowScroller();
        this.$nextTick(function () {
          if (!_this2.$refs.items || !_this2.$refs.items[_this2.currentIndex]) {
            return;
          }

          _this2.refreshInkPosRadioAndPos();

          var prevTarget = _this2.$refs.items[_this2.currentIndex - 1];
          var nextTarget = _this2.$refs.items[_this2.currentIndex + 1];

          if (!prevTarget) {
            _this2.$refs.scroller.scrollTo(0, 0, _options.animate);

            return;
          }

          if (!nextTarget) {
            _this2.$refs.scroller.scrollTo(_this2.contentW, 0, _options.animate);

            _this2.maskEndShown = false; // 初始化时tab在最后一个右侧的渐变不显示

            return;
          }

          var wrapperRect = _this2.$refs.wrapper.getBoundingClientRect();

          var prevTargetRect = prevTarget.getBoundingClientRect();
          var nextTargetRect = nextTarget.getBoundingClientRect();
          /* istanbul ignore next */

          if (prevTargetRect && prevTargetRect.left < wrapperRect.left) {
            _this2.$refs.scroller.scrollTo(prevTarget.offsetLeft, 0, _options.animate);
          } else if (nextTargetRect && nextTargetRect.right > wrapperRect.right) {
            if (nextTarget.offsetLeft + nextTarget.offsetWidth - _this2.wrapperW > 0) {
              // 初始化时tab不在一个时且tab有滑动左侧的渐变显示
              _this2.maskStartShown = true;
            }

            _this2.$refs.scroller.scrollTo(nextTarget.offsetLeft + nextTarget.offsetWidth - _this2.wrapperW, 0, _options.animate);
          }
        });
      },
      refreshInkPosRadioAndPos: function refreshInkPosRadioAndPos() {
        var currentTab = this.$refs.items[this.currentIndex];
        var wrapperRect = this.$el.getBoundingClientRect();
        var inkWidth = currentTab.offsetWidth; // 线条宽度

        var inkPos = currentTab.offsetLeft; // 线条定位left值
        // 内容区域滑动时，计算距离下个滑动过去的tab距离和宽度size

        var nextTabindex = this.inkPosRadio > 0 ? this.currentIndex + 1 : this.currentIndex - 1;
        var nextTab = this.$refs.items[nextTabindex];
        var nextLeft = 0;
        var nextSize = 0; // 计算下一个tab距离页面左侧的距离

        if (nextTab) {
          var nextDom = nextTab.lastChild;
          nextLeft = nextTab.offsetLeft - (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.left) || 0;
          nextSize = nextDom.offsetWidth;
        }

        var delta = (nextLeft - currentTab.offsetLeft) * Math.abs(this.inkPosRadio) + currentTab.offsetLeft; // 本次线条移动的距离

        if (delta) {
          inkPos = delta;
          inkWidth = (nextSize - currentTab.offsetWidth) * Math.abs(this.inkPosRadio) + currentTab.offsetWidth; // 滑动过程中宽度的变化
        } // 在存在手指滑动的情况下，才处理Y轴变化；点击tab-bar不触发


        if (this.isSlideTabBar) {
          if (this.inkPosRadio) {
            if (nextTab && nextTab.firstChild) {
              nextTab.firstChild.style.transform = "translateY(".concat(-4 * Math.abs(this.inkPosRadio), "%)");
            }

            if (currentTab && currentTab.firstChild) {
              currentTab.firstChild.style.transform = "translateY(".concat(-4 * (1 - Math.abs(this.inkPosRadio)), "%)");
            }
          } else {
            this.$refs.items && this.$refs.items.forEach(function (item) {
              if (item && item.firstChild) item.firstChild.style.transform = '';
            });
          }
        } // 首尾不做处理


        if (nextTabindex === this.items.length) return;

        if (nextTabindex === -1) {
          this.inkPos = currentTab.offsetLeft;
          this.inkWidth = currentTab.offsetWidth;
          return;
        }

        this.inkPos = inkPos;
        this.inkWidth = inkWidth;
      }
    }
  };
  _exports.default = _default2;
});